<template>
    <div class="counter-component">
      <div class="counter-btn" @click="minus">-</div>
      <div class="counter-show">
        <input type="text" v-model="number" @keyup="fixNumber">
      </div>
      <div class="counter-btn" @click="add">+</div>
    </div>
</template>

<script>
    import bus from '../../eventsCenter/bus'
    export default {
      props:{
        min:{
          type:Number,
          default:1
        },
        max:{
          type:Number,
          default:5
        },
      },
      created() {
        bus.$on('choose',this.choose)
      },
      data() {
          return {
             number:this.min
          }
      },
      watch:{
        number() {
          this.$emit('on-change',this.number)
        }
      },
      methods:{
        choose(value) {
          console.log('您点击了' + value + ';这行代码在counter组件执行！')
        },
        minus() {
          if(this.number <= this.min){
            return
          }
          this.number--
        },
        add() {
          if(this.number >= this.max){
            return
          }
          this.number++
        },
        fixNumber(){
          let fix;
          if(typeof this.number === 'string'){
            fix = Number(this.number.replace(/\D/g,''))
          }else{
            fix = this.number;
          }
          if(fix < this.min || fix > this.max){
            fix = this.min
          }
          this.number = fix
        }
      },
      beforeDestroy() {
        bus.$off('choose',this.choose)
      }
    }
</script>

<style scoped>
  .counter-component {
    position: relative;
    display: inline-block;
    overflow: hidden;
    vertical-align: middle;
  }
  .counter-show {
    float: left;
  }
  .counter-show input {
    border: none;
    border-top: 1px solid #e3e3e3;
    border-bottom: 1px solid #e3e3e3;
    height: 23px;
    line-height: 23px;
    width: 30px;
    outline: none;
    text-indent: 4px;
  }
  .counter-btn {
    border: 1px solid #e3e3e3;
    float: left;
    height: 25px;
    line-height: 25px;
    width: 25px;
    text-align: center;
    cursor: pointer;
  }
  .counter-btn:hover {
    border-color: #363636;
    background: #363636;
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/base/counter.vue